
















import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import MainLayout from '@/modules/common/layout/components/shared/MainLayout.vue'
import { ErrorMessages, FlushMessages } from '@/modules/common/layout/models/types/Messages'
import PanelTopHeader from '@/modules/common/layout/components/panel/PanelTopHeader.vue'
import PanelDrawer from '@/modules/common/layout/components/panel/PanelDrawer.vue'
import PopupNotificationGlobal from '@/modules/common/layout/components/shared/notification/PopupNotificationGlobal.vue'
import CtaButton from '@/modules/shared/components/shared/kit/CtaButton.vue'
import SocialIcon from '@/modules/shared/components/shared/icon/SocialIcon.vue'

@Component({
  metaInfo: {
    title: 'نیک‌نویس'
  },
  components: {
    SocialIcon,
    CtaButton,
    PopupNotificationGlobal,
    PanelDrawer,
    PanelTopHeader,
    MainLayout
  }
})
export default class WebLayout extends MainLayout {

  @Prop() errors!: ErrorMessages
  @Prop() flush!: FlushMessages

}
